import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex gap-2 justify-end" }
const _hoisted_2 = { class: "manual-charges__filters-header" }
const _hoisted_3 = { class: "d-flex align-center gap-2" }
const _hoisted_4 = { class: "d-flex flex-column gap-2" }
const _hoisted_5 = { class: "d-flex flex-column gap-2" }
const _hoisted_6 = { class: "manual-charges__filters-footer text-caption text-gray-500" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  colspan: "9",
  class: "py-8 text-center text-body-2 text-gray-500"
}
const _hoisted_9 = { class: "text-body-2 font-weight-medium" }
const _hoisted_10 = { class: "text-body-2 font-weight-medium" }
const _hoisted_11 = { class: "text-caption text-gray-500" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_13 = {
  class: "text-body-2 font-weight-semibold",
  style: {"color":"#f97316"}
}
const _hoisted_14 = { class: "text-caption text-gray-500" }
const _hoisted_15 = {
  key: 1,
  class: "text-body-2 font-weight-semibold"
}
const _hoisted_16 = { class: "text-body-2" }
const _hoisted_17 = { class: "text-caption" }
const _hoisted_18 = {
  key: 2,
  class: "text-caption text-disabled"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex gap-2 justify-center"
}
const _hoisted_21 = {
  key: 1,
  class: "text-caption text-gray-500"
}
const _hoisted_22 = {
  key: 1,
  class: "d-flex justify-center mt-4"
}
const _hoisted_23 = {
  key: 0,
  class: "d-flex flex-column align-center gap-3"
}
const _hoisted_24 = {
  key: 1,
  class: "d-flex justify-center py-6"
}
const _hoisted_25 = { class: "text-body-2 mb-4" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "mt-2 px-3 py-2 rounded",
  style: {"background-color":"rgba(251, 146, 60, 0.1)"}
}
const _hoisted_28 = {
  class: "text-body-2 font-weight-bold",
  style: {"color":"#f97316"}
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "mt-2 px-3 py-2 rounded",
  style: {"background-color":"rgba(66, 153, 225, 0.1)"}
}
const _hoisted_31 = { class: "text-body-2 text-primary font-weight-bold" }
const _hoisted_32 = { class: "text-body-2 mb-4" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "manual-charges w-full mx-auto pa-4 my-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 rounded-xl" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            align: "center",
            justify: "space-between",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1" }, [
                    _createElementVNode("h2", { class: "text-h6 font-weight-bold mb-1" }, "لیست شارژ دستی"),
                    _createElementVNode("span", { class: "text-caption text-gray-500" }, " مدیریت درخواست‌های شارژ دستی ثبت‌شده توسط کاربران و تایید آنها پس از بررسی رسید پرداخت. ")
                  ], -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "text-end"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_chip, {
                      color: "primary",
                      variant: "flat",
                      size: "small",
                      class: "text-caption font-weight-medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" مجموع نتایج: " + _toDisplayString(_ctx.totalItemsFormatted), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "manual-charges__filters mb-4",
            elevation: "1",
            rounded: "lg"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "d-flex flex-column gap-1" }, [
                  _createElementVNode("span", { class: "text-subtitle-2 font-weight-medium" }, "فیلتر پیشرفته نتایج"),
                  _createElementVNode("span", { class: "text-caption text-gray-500" }, "به کمک وضعیت‌ها و جستجو سریع‌تر به نتیجه برسید.")
                ], -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "secondary",
                    class: "text-caption font-weight-medium",
                    disabled: !_ctx.hasActiveFilters && !_ctx.manualChargesLoading,
                    onClick: _ctx.resetFilters
                  }, {
                    default: _withCtx(() => [
                      _cache[26] || (_cache[26] = _createTextVNode(" بازنشانی فیلترها ", -1)),
                      _createVNode(_component_v_icon, {
                        end: "",
                        size: "16"
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("mdi-restore", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    rounded: "lg",
                    class: "text-caption font-weight-medium",
                    loading: _ctx.manualChargesLoading,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshList()))
                  }, {
                    default: _withCtx(() => [
                      _cache[28] || (_cache[28] = _createTextVNode(" تازه‌سازی داده‌ها ", -1)),
                      _createVNode(_component_v_icon, {
                        end: "",
                        size: "18"
                      }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("mdi-refresh", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _createVNode(_component_v_divider, { class: "my-4" }),
              _createVNode(_component_v_row, {
                class: "manual-charges__filters-grid",
                align: "center",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-caption text-gray-500" }, "وضعیت درخواست", -1)),
                        _createVNode(_component_v_chip_group, {
                          modelValue: _ctx.selectedStatus,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStatus) = $event)),
                            _ctx.handleStatusChipChange
                          ],
                          mandatory: "",
                          class: "manual-charges__status-chip-group"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (option) => {
                              return (_openBlock(), _createBlock(_component_v_chip, {
                                key: option.value,
                                value: option.value,
                                "prepend-icon": option.icon,
                                variant: _ctx.selectedStatus === option.value ? 'flat' : 'outlined',
                                color: _ctx.selectedStatus === option.value ? option.color : undefined,
                                rounded: "lg",
                                class: _normalizeClass([
                    'manual-charges__status-chip',
                    `manual-charges__status-chip--${option.value.toLowerCase()}`,
                    { 'manual-charges__status-chip--active': _ctx.selectedStatus === option.value }
                  ])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(option.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "prepend-icon", "variant", "color", "class"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-caption text-gray-500" }, "نوع شارژ", -1)),
                        _createVNode(_component_v_chip_group, {
                          modelValue: _ctx.selectedChargeType,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedChargeType) = $event)),
                            _ctx.handleChargeTypeChipChange
                          ],
                          mandatory: "",
                          class: "manual-charges__status-chip-group"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chargeTypeOptions, (option) => {
                              return (_openBlock(), _createBlock(_component_v_chip, {
                                key: option.value,
                                value: option.value,
                                "prepend-icon": option.icon,
                                variant: _ctx.selectedChargeType === option.value ? 'flat' : 'outlined',
                                color: _ctx.selectedChargeType === option.value ? option.color : undefined,
                                rounded: "lg",
                                class: _normalizeClass([
                    'manual-charges__status-chip',
                    `manual-charges__status-chip--${option.value.toLowerCase()}`,
                    { 'manual-charges__status-chip--active': _ctx.selectedChargeType === option.value }
                  ])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(option.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "prepend-icon", "variant", "color", "class"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.searchQuery,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery) = $event)),
                        label: "جستجوی سریع",
                        placeholder: "نام کاربر، ایمیل، شناسه یا کد رهگیری",
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        clearable: "",
                        "prepend-inner-icon": "mdi-magnify"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedPageSize,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPageSize) = $event)),
                          _ctx.handlePageSizeChange
                        ],
                        items: _ctx.pageSizeOptions,
                        label: "تعداد آیتم در هر صفحه",
                        variant: "outlined",
                        density: "compact",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.filterSummary), 1)
            ]),
            _: 1
          }),
          (_ctx.manualChargesLoading)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                color: "primary",
                indeterminate: "",
                class: "mb-2"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_table, {
            density: "comfortable",
            class: "manual-charges__table rounded-xl"
          }, {
            default: _withCtx(() => [
              _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "شناسه"),
                  _createElementVNode("th", null, "نوع شارژ"),
                  _createElementVNode("th", null, "کاربر"),
                  _createElementVNode("th", null, "مبلغ (تومان)"),
                  _createElementVNode("th", null, "کد رهگیری"),
                  _createElementVNode("th", null, "وضعیت"),
                  _createElementVNode("th", null, "تاریخ ایجاد"),
                  _createElementVNode("th", null, "جزئیات"),
                  _createElementVNode("th", { class: "text-center" }, "عملیات")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (!_ctx.manualChargesLoading && _ctx.displayedManualCharges.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.emptyStateMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedManualCharges, (charge) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: charge.id
                  }, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(charge.id), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        color: _ctx.chargeTypeColor(charge.chargeType),
                        variant: "flat",
                        class: "text-caption font-weight-medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.chargeTypeLabel(charge.chargeType)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(charge.user?.name ?? 'نامشخص'), 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(charge.user?.mail ?? charge.user?.email ?? 'ایمیل ثبت نشده'), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (charge.chargeType === 'CRYPTO')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(charge.cryptoAmount ?? '—') + " USDT ", 1),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatAmount(charge.amount)) + " تومان ", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.formatAmount(charge.amount)) + " تومان ", 1))
                    ]),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(charge.trackingCode ?? '—'), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        color: _ctx.statusColor(charge.status),
                        variant: "flat",
                        class: "text-caption font-weight-medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.statusLabel(charge.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDate(charge.createdAt)), 1),
                    _createElementVNode("td", null, [
                      (charge.chargeType === 'CRYPTO')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            variant: "text",
                            color: "primary",
                            size: "small",
                            class: "text-caption",
                            "prepend-icon": "mdi-information",
                            onClick: ($event: any) => (_ctx.openCryptoDetails(charge))
                          }, {
                            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                              _createTextVNode(" کریپتو ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (charge.receipt)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              variant: "text",
                              color: "primary",
                              size: "small",
                              class: "text-caption",
                              "prepend-icon": "mdi-file-eye",
                              onClick: ($event: any) => (_ctx.openReceipt(charge))
                            }, {
                              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                _createTextVNode(" رسید ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      (charge.status === 'PENDING')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_v_btn, {
                              color: "success",
                              rounded: "lg",
                              size: "small",
                              class: "text-caption font-weight-medium",
                              loading: _ctx.isApproving(charge.id) || _ctx.approveDialog.loading,
                              disabled: _ctx.isApproving(charge.id) || _ctx.manualChargesLoading || _ctx.rejectDialog.loading,
                              onClick: ($event: any) => (_ctx.openApproveDialog(charge))
                            }, {
                              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                _createTextVNode(" تایید ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading", "disabled", "onClick"]),
                            _createVNode(_component_v_btn, {
                              color: "error",
                              rounded: "lg",
                              size: "small",
                              class: "text-caption font-weight-medium",
                              loading: _ctx.isRejecting(charge.id) || _ctx.rejectDialog.loading,
                              disabled: _ctx.isRejecting(charge.id) || _ctx.manualChargesLoading || _ctx.approveDialog.loading,
                              onClick: ($event: any) => (_ctx.openRejectDialog(charge))
                            }, {
                              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                _createTextVNode(" رد ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading", "disabled", "onClick"])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          (_ctx.manualChargesPagination.totalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_v_pagination, {
                  "model-value": _ctx.manualChargesFilters.page,
                  length: _ctx.manualChargesPagination.totalPages,
                  "total-visible": 7,
                  rounded: "lg",
                  color: "primary",
                  "onUpdate:modelValue": _ctx.handlePageChange
                }, null, 8, ["model-value", "length", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.receiptDialog.open,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receiptDialog.open) = $event)),
        "max-width": "720px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold d-flex justify-space-between align-center" }, {
                default: _withCtx(() => [
                  _cache[38] || (_cache[38] = _createElementVNode("span", null, "رسید پرداخت", -1)),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    size: "small",
                    onClick: _ctx.closeReceipt
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_ctx.receiptHasImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_ctx.receiptDialog.loading)
                          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                              key: 0,
                              color: "primary",
                              indeterminate: "",
                              class: "w-100"
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_img, {
                          src: _ctx.receiptImageSource,
                          alt: `رسید شارژ ${_ctx.receiptDialog.trackingCode || ''}`,
                          class: "rounded-lg receipt-preview",
                          "max-height": "700",
                          width: "100%",
                          contain: ""
                        }, null, 8, ["src", "alt"]),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "primary",
                          size: "small",
                          class: "text-caption",
                          "append-icon": "mdi-open-in-new",
                          onClick: _ctx.openReceiptInNewTab
                        }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode(" باز کردن تصویر در تب جدید ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : (_ctx.receiptDialog.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "primary",
                            size: "40"
                          })
                        ]))
                      : (_ctx.receiptDialog.error)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 2,
                            type: "error",
                            variant: "tonal",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.receiptDialog.error), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_alert, {
                            key: 3,
                            type: "info",
                            variant: "tonal",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                              _createTextVNode(" تصویری برای این رسید در دسترس نیست. ", -1)
                            ]))]),
                            _: 1
                          }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.approveDialog.open,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.approveDialog.open) = $event)),
        "max-width": "480px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(" تایید شارژ دستی " + _toDisplayString(_ctx.approveDialog.chargeType === 'CRYPTO' ? 'کریپتو' : 'ریالی'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_25, [
                    _createTextVNode(" آیا از تایید شارژ " + _toDisplayString(_ctx.approveDialog.chargeType === 'CRYPTO' ? 'کریپتو' : '') + " برای ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.approveDialog.userName), 1),
                    _createTextVNode(" با کد رهگیری " + _toDisplayString(_ctx.approveDialog.trackingCode || '—') + " مطمئن هستید؟ ", 1)
                  ]),
                  (_ctx.approveDialog.chargeType === 'CRYPTO')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.approveDialog.editableCryptoAmount,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.approveDialog.editableCryptoAmount) = $event)),
                          modelModifiers: { number: true },
                          label: "مقدار کریپتو (USDT)",
                          variant: "outlined",
                          density: "compact",
                          type: "number",
                          step: "0.01",
                          "hide-details": "auto",
                          rules: [
                (v) => !!v || 'مقدار کریپتو الزامی است',
                (v) => !isNaN(Number(v)) || 'مقدار باید عدد باشد',
                (v) => Number(v) > 0 || 'مقدار باید بیشتر از صفر باشد'
              ]
                        }, {
                          "prepend-inner": _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createElementVNode("span", { class: "text-caption text-gray-500" }, "USDT", -1)
                          ]))]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        (_ctx.formattedApproveCryptoAmount)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-caption text-gray-700" }, "مقدار کریپتو: ", -1)),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formattedApproveCryptoAmount) + " USDT", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.approveDialog.editableAmount,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.approveDialog.editableAmount) = $event)),
                          modelModifiers: { number: true },
                          label: "مبلغ (تومان)",
                          variant: "outlined",
                          density: "compact",
                          type: "number",
                          "hide-details": "auto",
                          rules: [
                (v) => !!v || 'مبلغ الزامی است',
                (v) => !isNaN(Number(v)) || 'مبلغ باید عدد باشد',
                (v) => Number(v) > 0 || 'مبلغ باید بیشتر از صفر باشد'
              ]
                        }, {
                          "prepend-inner": _withCtx(() => [...(_cache[43] || (_cache[43] = [
                            _createElementVNode("span", { class: "text-caption text-gray-500" }, "تومان", -1)
                          ]))]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        (_ctx.formattedApproveAmount)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-caption text-gray-700" }, "مبلغ: ", -1)),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formattedApproveAmount) + " تومان", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end gap-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "secondary",
                    disabled: _ctx.approveDialog.loading,
                    onClick: _ctx.closeApproveDialog
                  }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode(" انصراف ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "success",
                    rounded: "lg",
                    class: "text-caption font-weight-medium",
                    loading: _ctx.approveDialog.loading,
                    disabled: !_ctx.isApproveAmountValid,
                    onClick: _ctx.confirmApprove
                  }, {
                    default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                      _createTextVNode(" تایید نهایی ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.rejectDialog.open,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rejectDialog.open) = $event)),
        "max-width": "480px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(" رد شارژ دستی " + _toDisplayString(_ctx.rejectDialog.chargeType === 'CRYPTO' ? 'کریپتو' : 'ریالی'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_32, [
                    _cache[47] || (_cache[47] = _createTextVNode(" آیا از رد شارژ ", -1)),
                    (_ctx.rejectDialog.chargeType === 'CRYPTO')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.rejectDialog.cryptoAmount) + " USDT", 1),
                          _createTextVNode(" (معادل " + _toDisplayString(_ctx.formatAmount(_ctx.rejectDialog.amount)) + " تومان) ", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("strong", _hoisted_34, _toDisplayString(_ctx.formatAmount(_ctx.rejectDialog.amount)) + " تومان", 1)),
                    _cache[48] || (_cache[48] = _createTextVNode(" برای ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.rejectDialog.userName), 1),
                    _cache[49] || (_cache[49] = _createTextVNode(" مطمئن هستید؟ ", -1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end gap-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "secondary",
                    disabled: _ctx.rejectDialog.loading,
                    onClick: _ctx.closeRejectDialog
                  }, {
                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                      _createTextVNode(" انصراف ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    rounded: "lg",
                    class: "text-caption font-weight-medium",
                    loading: _ctx.rejectDialog.loading,
                    onClick: _ctx.confirmReject
                  }, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createTextVNode(" رد نهایی ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.cryptoDetailsDialog.open,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cryptoDetailsDialog.open) = $event)),
        "max-width": "720px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold d-flex justify-space-between align-center" }, {
                default: _withCtx(() => [
                  _cache[53] || (_cache[53] = _createElementVNode("span", null, "جزئیات شارژ کریپتو", -1)),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    size: "small",
                    onClick: _ctx.closeCryptoDetails
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_ctx.cryptoDetailsDialog.charge)
                    ? (_openBlock(), _createBlock(_component_v_list, {
                        key: 0,
                        dense: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                  _createTextVNode("مبلغ کریپتو", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.cryptoAmount ?? '—') + " USDT ", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                  _createTextVNode("شبکه", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.cryptoNetwork ?? '—'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                  _createTextVNode("Transaction Hash", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium text-break" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.txHash ?? '—'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          (_ctx.cryptoDetailsDialog.charge.senderAddress)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                      _createTextVNode("آدرس فرستنده", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium text-break" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.senderAddress), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.senderAddress)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.receiverAddress)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                      _createTextVNode("آدرس گیرنده", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium text-break" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.receiverAddress), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.receiverAddress)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 3 }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.blockNumber)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                    default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                      _createTextVNode("شماره بلاک", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.blockNumber), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.blockNumber)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 5 }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.confirmations)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                    default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                      _createTextVNode("تاییدیه‌ها", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-medium" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.confirmations), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.confirmations)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 7 }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.blockchainTxUrl)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 8 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                    default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                      _createTextVNode("لینک Explorer", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "primary",
                                        size: "small",
                                        class: "text-caption px-0",
                                        "append-icon": "mdi-open-in-new",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openBlockchainExplorer(_ctx.cryptoDetailsDialog.charge.blockchainTxUrl)))
                                      }, {
                                        default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                          _createTextVNode(" مشاهده در بلاکچین ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.description)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 9 }))
                            : _createCommentVNode("", true),
                          (_ctx.cryptoDetailsDialog.charge.description)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 10 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-gray-500" }, {
                                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                      _createTextVNode("توضیحات", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cryptoDetailsDialog.charge.description), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.createCryptoDialog.open,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.createCryptoDialog.open) = $event)),
        "max-width": "800px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold d-flex justify-space-between align-center" }, {
                default: _withCtx(() => [
                  _cache[65] || (_cache[65] = _createElementVNode("span", null, "ایجاد شارژ دستی کریپتو", -1)),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    size: "small",
                    onClick: _ctx.closeCreateCryptoDialog
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, { ref: "cryptoForm" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { dense: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.userId,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.createCryptoDialog.form.userId) = $event)),
                                label: "شناسه کاربر",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                rules: [(v) => !!v || 'شناسه کاربر الزامی است']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.createCryptoDialog.form.cryptoNetwork,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.createCryptoDialog.form.cryptoNetwork) = $event)),
                                label: "شبکه کریپتو",
                                items: ['TRC20', 'BEP20', 'ERC20', 'POLYGON', 'ARBITRUM'],
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.cryptoAmount,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.createCryptoDialog.form.cryptoAmount) = $event)),
                                modelModifiers: { number: true },
                                label: "مقدار کریپتو (USDT)",
                                variant: "outlined",
                                density: "compact",
                                type: "number",
                                step: "0.01",
                                "hide-details": "auto",
                                rules: [
                    (v) => !!v || 'مقدار کریپتو الزامی است',
                    (v) => Number(v) > 0 || 'مقدار باید بیشتر از صفر باشد'
                  ]
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.amount,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.createCryptoDialog.form.amount) = $event)),
                                modelModifiers: { number: true },
                                label: "معادل ریالی (تومان)",
                                variant: "outlined",
                                density: "compact",
                                type: "number",
                                "hide-details": "auto",
                                rules: [
                    (v) => !!v || 'معادل ریالی الزامی است',
                    (v) => Number(v) > 0 || 'مبلغ باید بیشتر از صفر باشد'
                  ]
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.txHash,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.createCryptoDialog.form.txHash) = $event)),
                                label: "Transaction Hash",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                rules: [
                    (v) => !!v || 'TxHash الزامی است',
                    (v) => v.length >= 10 || 'TxHash معتبر نیست'
                  ]
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.senderAddress,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.createCryptoDialog.form.senderAddress) = $event)),
                                label: "آدرس فرستنده",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.receiverAddress,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.createCryptoDialog.form.receiverAddress) = $event)),
                                label: "آدرس گیرنده",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.blockchainTxUrl,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.createCryptoDialog.form.blockchainTxUrl) = $event)),
                                label: "لینک Explorer",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                placeholder: "https://tronscan.org/#/transaction/..."
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.blockNumber,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.createCryptoDialog.form.blockNumber) = $event)),
                                label: "شماره بلاک",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.createCryptoDialog.form.confirmations,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.createCryptoDialog.form.confirmations) = $event)),
                                modelModifiers: { number: true },
                                label: "تعداد تاییدیه‌ها",
                                variant: "outlined",
                                density: "compact",
                                type: "number",
                                "hide-details": "auto"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.createCryptoDialog.form.description,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.createCryptoDialog.form.description) = $event)),
                                label: "توضیحات",
                                variant: "outlined",
                                density: "compact",
                                rows: "3",
                                "hide-details": "auto"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end gap-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "secondary",
                    disabled: _ctx.createCryptoDialog.loading,
                    onClick: _ctx.closeCreateCryptoDialog
                  }, {
                    default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                      _createTextVNode(" انصراف ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "success",
                    rounded: "lg",
                    class: "text-caption font-weight-medium",
                    loading: _ctx.createCryptoDialog.loading,
                    onClick: _ctx.submitCreateCrypto
                  }, {
                    default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                      _createTextVNode(" ثبت شارژ کریپتو ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}